import { useEffect, useState } from 'react';
import { message } from 'antd';
import { Order } from 'types';
import API from '../../API';

type ReturnType = [Order[] | undefined, () => Promise<void>];

interface Params {
	after?: moment.Moment | undefined;
	before?: moment.Moment | undefined;
	clientId?: number | undefined;
	search?: string | undefined;
	done?: boolean | undefined;
}

export const useOrders = (params: Params): ReturnType => {
	const [orders, setOrders] = useState<Order[]>();

	useEffect(() => {
		fetchOrders();
	}, [params.after?.unix(), params.before?.unix(), params.clientId, params.done]);

	const fetchOrders = async () => {
		try {
			const orders = await API.orders2.getAll({
				after: params.after,
				before: params.before,
				clientId: params.clientId,
				done: params.done,
			});

			setOrders(orders);
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się pobrać danych (${e})`);
		}
	};

	const filtered = orders?.filter((o) => {
		if (!params.search) {
			return true;
		}

		const search = params.search.toLocaleLowerCase();
		if (o.client.name.toLocaleLowerCase().includes(search)) return true;
		if (o.client.phone.toLocaleLowerCase().includes(search)) return true;
		if (o.contact?.toLocaleLowerCase().includes(search)) return true;
		if (o.address.toLocaleLowerCase().includes(search)) return true;
		if (o.wasteType.toLocaleLowerCase().includes(search)) return true;

		return false;
	});

	return [filtered, fetchOrders];
};
